import { useNavLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import PropTypes from 'prop-types';

import { MenuItem } from '../MenuItem';
import * as Styled from './EntityMenuItem.style';

function EntityMenuItem({ entity, onClick }) {
  const handleClickTracking = useNavLinkPressedCallback(entity.eventProps);

  const handleClickEntity = () => {
    handleClickTracking();
    onClick();
  };

  return (
    <MenuItem
      onClick={handleClickEntity}
      variant={entity.hasNameReservation ? 'reserved' : ''}
    >
      <Styled.Link role="menuitem" to={entity.path}>
        <Styled.TruncatedText>{entity.name}</Styled.TruncatedText>
        {entity.hasNameReservation && (
          <Styled.Pill color="creativity40" size="md">
            Reserved
          </Styled.Pill>
        )}
      </Styled.Link>
    </MenuItem>
  );
}

EntityMenuItem.propTypes = {
  entity: PropTypes.shape({
    hasNameReservation: PropTypes.bool.isRequired,
    eventProps: PropTypes.shape({
      elementName: PropTypes.string,
      navIndex: PropTypes.number,
      navLevel: PropTypes.number,
      pageCategory: PropTypes.string,
      pageSection: PropTypes.string
    }).isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired
};

export default EntityMenuItem;
